import { render, staticRenderFns } from "./MessagesTop.vue?vue&type=template&id=61fb500c&scoped=true"
import script from "./MessagesTop.vue?vue&type=script&lang=js"
export * from "./MessagesTop.vue?vue&type=script&lang=js"
import style0 from "./MessagesTop.vue?vue&type=style&index=0&id=61fb500c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb500c",
  null
  
)

export default component.exports